import { defineStore } from 'pinia'

export const appStore = defineStore('mainStore', {
    state: () => ({
        loggedIn: false, // Initialize as false, then check in mounted/created
        user: null,
        token: null,
        darkTheme: localStorage.getItem('darkTheme') === 'true',
    }),

    getters: {
        isLoggedIn: (state) => state.loggedIn,
        getUser: (state) => state.user,
        // token: (state) => state.token,
    },

    actions: {
         // Initialize auth state from localStorage
        initAuth() {
            // const storedToken = localStorage.getItem('authToken');
            // const token = storedToken == "null" ? null : storedToken;
            const token = localStorage.getItem('authToken');
            this.token = token;
            this.loggedIn = token !== null;

            const userStr = localStorage.getItem('user');
            if(userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (error) {
                    console.error('Error parsing user from localStorage:', error);
                    this.user = null;
                }
            }
        },

        login(token) {
            try {
                localStorage.setItem('authToken', token);
                this.token = token;
                this.loggedIn = true;
            } catch (error) {
                console.error('Error setting auth token:', error);
            }
        },

        logout() {
            try {
                localStorage.removeItem('authToken');
                this.loggedIn = false;
            } catch (error) {
                console.error('Error removing auth token:', error);
            }
        },

        setUser(user) {
            this.user = user;
            try{
                localStorage.setItem('user', JSON.stringify(user));
            } catch (error) {
                console.error('Error saving user to localStorage:', error);
            }
        },

        setToken(token){
            this.token = token;
            try{
                localStorage.setItem('authToken', token)
            } catch (error) {
                console.error('Error saving user to localStorage:', error);
            }
        },

        setDarkTheme(value){
            this.darkTheme = value;
            localStorage.setItem('darkTheme', value)
        },

        resetLocalStorage(){
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
        },

        reset(){
            this.loggedIn = false; // Initialize as false, then check in mounted/created
            this.user =  null;
            this.token = null;
            this.darkTheme = false;
            this.resetLocalStorage()
        }
    }
})